<template>
  <v-container fluid class="docForm">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Purchase Returns / Debit Note</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <div>
          <v-row dense>
            <!-- datepicker 2 -->
            <v-col cols="12" xs="12" md="3">
              <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field dense outlined single-line v-model="record.StartDate" label="From"
                    prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker v-model="record.StartDate" @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <!-- datepicker 2 -->
            <v-col cols="12" xs="12" md="3">
              <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field dense outlined single-line v-model="record.EndDate" label="To"
                    prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker v-model="record.EndDate" @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" xs="12" md="3">
              <v-autocomplete autocomplete="off" dense outlined v-model="record.SupplierId" :items="suppliers"
                label="Supplier" item-text="Name" item-value="id"></v-autocomplete>
            </v-col>

            <v-col cols="12" xs="12" md="3">
              <v-btn class="right" color="primary" :loading="loader" @click="getReport">Query Data</v-btn>
            </v-col>
          </v-row>


          <v-row dense>
            <v-col cols="12">
              <v-text-field dense label="Search" v-model="search"></v-text-field>
            </v-col>

            <v-divider></v-divider>
          </v-row>

        </div>
      </v-card-text>
    </v-card>

    <!-- start of default dialog -->
    <v-dialog v-model="invoicesDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar color="secondary" flat dense>
          <v-toolbar-title>
            <v-btn icon @click="invoicesDialog = false">
              <v-icon>mdi-keyboard-backspace</v-icon>
            </v-btn>Purchase Return
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="invoicesDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-row justify="center" class="mt-3">
            <v-col cols="10">
              <v-row class="mt-2">
                <v-col cols="12">
                  <v-text-field dense label="Search" v-model="searchInvoices"></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-data-table :mobile-breakpoint="0" :items-per-page="pageItems" :headers="headers"
                    :items="purchases" :search="search">
                    <!-- template -->
                    <template v-slot:item.DocTotal="{ item }">{{ item.DocTotal | currency }}</template>
                    <!-- end -->
                    <!-- template -->
                    <template v-slot:item.TotalPaid="{ item }">
                      {{
                        item.TotalPaid | currency
                      }}
                    </template>
                    <!-- end -->
                    <!-- template -->
                    <template v-slot:item.Balance="{ item }">
                      {{
                        item.Balance | currency
                      }}
                    </template>
                    <!-- end -->

                    <!-- template -->
                    <template v-slot:item.Date="{ item }">
                      {{
                        item.Date | date
                      }}
                    </template>
                    <!-- end -->

                    <!-- action template -->
                    <template v-slot:item.action="{ item }">
                      <v-btn color="accent" text :to="`/debit-notes/${item.id}`">
                        <v-icon left>mdi-clipboard-arrow-left</v-icon>Return Purchases
                      </v-btn>
                    </template>
                    <!-- end -->
                  </v-data-table>
                  <!-- snackbar -->
                  <snackbar ref="snackbar"></snackbar>
                </v-col>


              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of default dialog -->
  </v-container>
</template>

<script>
import "export-json-excel";
export default {
  computed: {
    storeName() {
      return localStorage.getItem("storeName");
    },
    role() {
      return localStorage.getItem("userRole");
    }
  },
  data() {
    return {
      record: {},
      invoicesDialog: false,
      searchInvoices: null,
      productsDialog: false,
      salesLoader: false,
      soldItems: [],
      pageItems: 100,
      zeroValue: 0,
      menu1: false,
      menu2: false,
      loader: false,
      search: null,
      suppliers: [],
      reportData: {},
      TotalReturns: null,
      TotalServices: 0,
      returnsData: [],
      reportDataAllSales: [],
      cancelledDialog: false,
      cancelledData: [],
      purchases: [],
      drivers: [],
      dailySales: [],
      totalPurchases: 0,
      totalPayments: 0,
      creditSales: 0,
      date: new Date().toISOString().substr(0, 10),
      headers: [
        { text: "Doc Num.", value: "DocNum" },
        { text: "Supplier", value: "SupplierName" },
        { text: "Total", value: "DocTotal" },
        { text: "Date", value: "Date" },
        { text: "Action", value: "action", sortable: false }
      ]
    };
  },
  methods: {
    setStartDate(date) {
      this.record.StartDate = date;
    },
    setEndDate(date) {
      this.record.EndDate = date;
    },
    getReport() {
      let data = this.record;

      const self = this;
      const url = `/daily-purchases-report`;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.purchases = res.ResponseData.purchases;
            self.loader = false;
            self.invoicesDialog = true;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.loader = false;
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getSuppliers() {
      const self = this;
      this.$store
        .dispatch("get", `/suppliers`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.suppliers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getSuppliers();
  }
};
</script>

<style lang="scss" scoped></style>